/** Verkstadsmodulerna har egna sidor. Meny-raderna i databasen pekar ibland på rutter som saknas. */
const WORKSHOP_MODULE_ROUTES: Record<string, string> = {
  service: '/workshop/service',
  inspections: '/workshop/inspections',
  repairs: '/workshop/repairs',
};

export function resolveWorkshopModuleRoute(
  systemName: string | undefined,
  moduleName: string,
  route?: string | null
): string | undefined {
  if (String(systemName || '').trim().toLowerCase() === 'workshop') {
    const override = WORKSHOP_MODULE_ROUTES[moduleName];
    if (override) return override;
  }
  const trimmed = String(route || '').trim();
  return trimmed || undefined;
}
